export const getAiHealthScoreStyles = (score: number | undefined | null) => {
  if (typeof score !== "number") {
    return {
      container: "border-slate-200 bg-slate-50 text-slate-700",
      text: "text-slate-800",
      label: "text-slate-500",
      badge: "bg-slate-100 text-slate-600",
    };
  }

  if (score >= 75) {
    return {
      container: "border-emerald-200 bg-emerald-50/70 text-emerald-900",
      text: "text-emerald-900",
      label: "text-emerald-700",
      badge: "bg-emerald-100 text-emerald-700",
    };
  }

  if (score >= 50) {
    return {
      container: "border-orange-200 bg-orange-50/70 text-orange-900",
      text: "text-orange-900",
      label: "text-orange-700",
      badge: "bg-orange-100 text-orange-700",
    };
  }

  return {
    container: "border-red-200 bg-red-50/70 text-red-900",
    text: "text-red-900",
    label: "text-red-700",
    badge: "bg-red-100 text-red-700",
  };
};
